import angular from "angular";
import { IUserService } from "@common/service/user.service";
import { IConfigService } from "@common/service/config.service";
import { ITeamInvitationService } from "@common/service/team.invitation.service";
import { ISubjectService } from "@common/service/subject.service";
import { TeamService } from "@common/service/team.service";
import { IPdfViewerService } from "@app/library/PdfViewer/service/pdfViewer.service";
import { IUserStateService } from "@common/service/userState.service";
import { IEnterpriseService } from "@common/service/enterprise.service";
import { PopUpService } from "@common/popup/popup.service";
import { IAppRootScopeService } from "@app/app.definition";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { PasswordCollectorService } from "@common/passwordCollector/services/passwordCollector.service";
import { WebSocketService } from "@common/service/web-socket.service";
import { PaymentService } from "@common/service/payment.service";
import { AppService } from "@app/app.service";
import { TeamPermissionService } from "@common/service/teamPermission.service";
import { IDocumentFolderService } from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import { SnackbarService } from "@common/service/snackbar.service";
import { CachingService } from "@common/service/caching.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { FormService } from "@common/service/form.service";
import { TeamVaultService } from "@common/service/teamvault.service";
import { PermissionsEnum, PermissionService, TargetEnum } from "ecv/common/permissions";
import { Util } from "@common/util";
import { FolderTypeCodes } from "@common/model/documentFolder";
import _ from "lodash";
import { Subject } from "@common/model/subject";
import { InviteInfo } from "@common/model/inviteInfo";
import {APP_URLS, MODULE_ACTIONS, MODULES, TEAMS_FILTER} from "@common/model/constants";
import { IConditionalModuleLoadService } from '@common/service/conditionalModuleLoad.service';


export class AppController {

    isDiscAllowed: boolean;

    static $inject = [
        "$scope", "$sce", "Idle", "$location", "PopUpService",
        "$window", "$q", "$state", "$rootScope", "$timeout",
        "ApiAdapterService", "CacheService", "PasswordCollectorService",
        "UserService", "ConfigService", "SubjectService", "TeamInvitationService", "TeamService",
        "PdfViewerService", "WebSocketService",
        "UserStateService", "PaymentService", "EnterpriseService", "AppService", "TeamPermissionService",
        "DocumentFolderService", "$filter", "$compile", "SnackbarService", "CachingService", "authConfig",
        "BroadcastService", "FormService", "PermissionService", "TeamVaultService", "$ocLazyLoad", "ConditionalModuleLoadService"];

    constructor(
        $scope: IAppScope,
        $sce: angular.ISCEService,
        Idle: any,
        $location: angular.ILocationService,
        PopUpService: PopUpService,
        $window: angular.IWindowService,
        $q: angular.IQService,
        $state: angular.ui.IStateService,
        $rootScope: IAppRootScopeService,
        $timeout: angular.ITimeoutService,
        ApiAdapterService: JavaApiAdapterService,
        CacheService: CacheService,
        PasswordCollectorService: PasswordCollectorService,
        UserService: IUserService,
        ConfigService: IConfigService,
        SubjectService: ISubjectService,
        $_teamInvitation: ITeamInvitationService,
        $_teamService: TeamService,
        $_pdfViewerSvc: IPdfViewerService,
        WebSocketService: WebSocketService,
        $_userState: IUserStateService,
        PaymentService: PaymentService,
        $_entSvc: IEnterpriseService,
        private AppService: AppService,
        private $_teamPerm: TeamPermissionService,
        private $_docFolderSvc: IDocumentFolderService,
        $filter: angular.IFilterService,
        $compile: angular.ICompileService,
        $_snack: SnackbarService,
        $_caching: CachingService,
        private authConfig: any,
        BroadcastService: BroadcastService,
        FormService: FormService, PermissionService: PermissionService, TeamVaultService: TeamVaultService, private $ocLazyLoad, private ConditionalModuleLoadService: IConditionalModuleLoadService) {
        $rootScope.rootShowLoader = false;
        this.isDiscAllowed = true;

        // Initialize the services
        ConfigService.init();
        $_userState.init();
        $_entSvc.init().then(() => {
            const features = CacheService.getFeatures();
            if (!features) {
                appVm.hasForm = false;
                appVm.hasService = false;
                appVm.hasAnalytics = false;
                appVm.hasGlobalDashboard = false;
            } else {
                appVm.hasForm = features.forms;
                appVm.hasService = features.services;
                appVm.hasAnalytics = features.analytics;
                appVm.hasGlobalDashboard = features.globalDashboard;
            }
        });
        $_pdfViewerSvc.init();
        AppService.init();

        const appVm: any = this;
        ConditionalModuleLoadService.getSearchService().then((searchService) => {
            appVm.$_searchSvc = searchService;
        });
        appVm.rlRoute = "parent-rl";
        appVm.documentListRoute = "parent-team-vault";
        appVm.discussionListRoute = "discussion-board";
        appVm.crSelectorSubjects = [];
        appVm.newTabMsg = Util.OPN_NEW_TAB_MSG;
        appVm.helpTabMsg = Util.HELP_TAB_MSG;
        appVm.checkAddRecipient = "parent-profile";
        appVm.isDiscAllowed = $_teamPerm.isDiscussionsAllowed();
        appVm.isTeammember = true;
        appVm.servicesAssigned = CacheService.getIsServicesAssigned();
        appVm.previousService = CacheService.getIsPreviousService();
        appVm.iconColor = "#ffffff";
        appVm.cache = CacheService;


        // Held in-memory on $rootScope: it survives the Vault Key overlay modal shown after an
        // idle-session timeout (that re-auth does NOT reload the SPA), but resets on a full page
        // reload so the banner re-appears after every reload — as required.
        $rootScope.showGetAppBanner =
            !$rootScope.getAppBannerDismissed && Util.isMobile();
        // Env-based logo URL (same env root used for bigLogoRedirectUrl).
        $rootScope.appBannerLogoUrl =
            this.authConfig.redirectUri + '/web-app/src/client/assets/images/ecv_logo_wo_text_small.png';

        $rootScope.dismissGetAppBanner = () => {
            $rootScope.getAppBannerDismissed = true;
            $rootScope.showGetAppBanner = false;
        };

        $rootScope.openAppStore = () => {
            const url = Util.isAndroid() ? APP_URLS.ANDROID_PLAY_STORE_URL : APP_URLS.IOS_APP_STORE_URL;
            window.open(url, '_blank', 'noopener');
        };

        appVm.fetchDocs = false;
        appVm.isAdminFeaturePerm = false;
        appVm.isUserManagePerm = false;
        appVm.isAdminFeatureCreateTeamPerm = false;
        appVm.isManageSystemMessagePerm = false;
        appVm.searchBy = {
            filterList: ['fullName', 'uniqueId']
        };
        $rootScope.canUsrCreateTeam = CacheService.get('isCreateTeamAllow', true);

        BroadcastService.registerCallBack('cr-selected', $scope.$id, () => {
            appVm.updateSelectedCR();
        });
        BroadcastService.registerCallBack('cr-updated', $scope.$id, () => {
            appVm.updateSelectedCR();
        });
        BroadcastService.registerCallBack('new-created-item', $scope.$id, () => {
            appVm.glblNavDisabled = (CacheService.getTotalSubjects() == 0);
        });

        BroadcastService.registerCallBack('glblNavDisabled', $scope.$id, () => {
            $rootScope.glblNavDisabled = appVm.glblNavDisabled = (CacheService.get('userMembership', true) == 0);
        });

        BroadcastService.registerCallBack('update-team-invitations', $scope.$id, (initial) => {
            appVm.pendingInvitations = $rootScope.pendingInvitations;
            appVm.teamInvitation = $rootScope.teamInvitations;
            if (appVm.teamInvitation.length > 0) {
                let ids = _.map(appVm.teamInvitation, 'subjectId');
                SubjectService.getSubjectListByIds(ids).then(subs => {
                    for (let i = 0; i < appVm.teamInvitation.length; i++) {
                        const item = subs[appVm.teamInvitation[i].subjectId];
                        if (!!item) {
                            appVm.teamInvitation[i].isFrozen = item.isFrozen;
                            appVm.teamInvitation[i].coCaptain = item.coCaptain;
                        }
                    }
                });

            }
            appVm.totalTeamInvitation = 0;
            for (let subject of appVm.teamInvitation) {
                if (!subject.isFrozen) {
                    for (let teamMember of subject.careTeamActions) {
                        appVm.totalTeamInvitation += 1;
                    }
                }
            }
            if (!!initial && !!$rootScope.afterSelfSignUp) {
                AppService.showTeamInvitationAlert();
            }
        });
        BroadcastService.registerCallBack('update-services-assigned', $scope.$id, () => {
            appVm.servicesAssigned = CacheService.getIsServicesAssigned();
        });
        BroadcastService.registerCallBack('add-new-team', $rootScope.$id, (partyId) => {
            !!partyId && ($_teamPerm.fetchPermissions(partyId));
        });
        $scope.$on('$destroy', function () {
            $_snack.savedSnackbarObject = $('#toast-container-main').clone(true);
            const validToastIds = Object.keys($_snack.snackbarObject);

            if ($($_snack.savedSnackbarObject[0]).children().not('span').length > 0)
                $($_snack.savedSnackbarObject[0]).children().not('span').each(function() {
                    const $toast = $(this);

                    const hasValidToastId = validToastIds.some(id =>
                        $toast[0].classList.contains(id)
                    );

                    if (!hasValidToastId) {
                        $toast.remove();
                    }
                });
            BroadcastService.removeCallBack('cr-selected', $scope.$id);
            BroadcastService.removeCallBack('cr-updated', $scope.$id);
            BroadcastService.removeCallBack('new-created-item', $scope.$id);
            BroadcastService.removeCallBack('glblNavDisabled', $scope.$id);
            BroadcastService.removeCallBack('update-team-invitations', $scope.$id);
            BroadcastService.removeCallBack('update-services-assigned', $scope.$id);
            BroadcastService.removeCallBack('add-new-team', $rootScope.$id);
        });

        appVm.currentUser = CacheService.getUser();
        appVm.currentUserId = appVm.currentUser.id;
        appVm.checkAccessForTeam = {
            partyId: appVm.currentUser.partyId,
            target: TargetEnum.TEAM
        }
        appVm.glblNavDisabled = (CacheService.get('userMembership', true) == 0);
        appVm.isMenuHeaderOpen = false;
        appVm.isQckActnHeaderOpen = true;
        appVm.isQuickActionFormOpen = false;
        appVm.isAdminFeatureOpen = false;
        appVm.isQuickActionServiceOpen = false;
        appVm.isQuickActionAnalyticsOpen = false;
        appVm.loginUserId = CacheService.getUser().userId;
        appVm.sideBarToggle = false;
        appVm.displayCRMenu = false;
        appVm.user = CacheService.getUser();
        // get the userExperience from the cache
        let userExperience = CacheService.getUserExperience();
        //If userExperience is available then update the showOrgBigLogo flag and bigLogoRedirectUrl
        if (!!userExperience && userExperience.features.branding) {
            //userExperience → branding → logo → style == “bigLogo” then set showOrgBigLogo to true
            appVm.showOrgBigLogo = userExperience.features.branding.logoStyle == "bigLogo" && !CacheService.getHideBigLogo();
            //userExperience → branding → logo → style == “classic” then set showLogo to true or if user has big orgLogoPermission
            appVm.showLogo = userExperience.features.branding.logoStyle == "classic" || appVm.showOrgBigLogo;
            $rootScope.organizationShortName = userExperience.sponsor.orgShortName;
        }
        // IF userExperience is not available then keep it as existing
        else {
            //Flag that will toggle if the bigLogo is not available.
            appVm.showOrgBigLogo = !CacheService.getHideBigLogo();
            appVm.showLogo = ($_teamPerm.orgPermissions[MODULES.LOGO][MODULE_ACTIONS.SHOW]);
            //After Refresh the organizationShortName is not available in rootScope so need to set again.
            if (!$rootScope.organizationShortName) {
                $rootScope.organizationShortName = (appVm.user.organizationShortName);
            }
        }
        appVm.bigLogoRedirectUrl = this.authConfig.redirectUri;
        //CallBack function that will call if the BigLogo is not available.
        appVm.handleErrSrcCallback = function () {
            appVm.showOrgBigLogo = false;
            CacheService.setHideBigLogo(true);
        }
        appVm.isCRSelectorScrolling = false;
        appVm.currentPlan = CacheService.getPInfo();
        appVm.features = CacheService.getFeatures();
        if (!$rootScope.canUsrCreateTeam || (!!appVm.currentPlan && (!appVm.currentPlan.planType || appVm.currentPlan.planType == "FREE") && !appVm.currentPlan.maxCR)) {
            appVm.checkAddRecipient = 'parent-profile';
        } else if (!!appVm.features.multipleTeam) {
            appVm.checkAddRecipient = 'parent-addmultiplesubject';
        } else {
            appVm.checkAddRecipient = 'parent-addrecipient';
        }

        $rootScope.glblNavDisabled = appVm.glblNavDisabled;
        $rootScope.$state = $state;
        // REVIEW
        const postUpdates = CacheService.getUpdateIndication("posts");
        const documentUpdates = CacheService.getUpdateIndication("documents");
        const discussionUpdates = CacheService.getUpdateIndication("discussions");

        $rootScope.postUpdates = postUpdates;
        $rootScope.documentUpdates = documentUpdates;
        $rootScope.discussionUpdates = discussionUpdates;

        //Re-populate notification tray
        const snackObj = $_snack.snackbarObject;
        if (Object.keys(snackObj).length !== 0) {
            $(document).ready(function () {
                $('#toast-container-main').replaceWith($_snack.savedSnackbarObject);
                $('#ecv-notification-tray').removeClass('ng-hide');
            });
        } else {
            $rootScope.ntClosed = false;
        }


        appVm.viewCalendar = () => {
            if (appVm.glblNavDisabled) {
                return false;
            }
            AppService.initTeamSelection();
            $state.go('view-calendar', {});
        }

        appVm.viewAnalytics = (reload?) => {
            if (appVm.glblNavDisabled) {
                return false;
            }
            if (this.$ocLazyLoad.isLoaded('eCareVault.analytics')) {
                if (reload) {
                    $state.go('parent.analytics.list-report', {}, { reload: true });
                    return;
                }
                $state.go('parent.analytics.list-report', {});
            } else {
                $state.go('analytics-load', {});
            }
        }
        appVm.viewGlobalDashboard = () => {
            if (appVm.glblNavDisabled) {
                return false;
            }
            AppService.initTeamSelection();
            $state.go('dashboard-load',);
        }

        appVm.viewResourceLibrary = () => {
            if (appVm.glblNavDisabled) {
                return false;
            }
            AppService.initTeamSelection();
            $state.go('documents-load', { action: 'list-rl' });
        }

        $rootScope.toggleNotificationTray = (open?) => {
            if (!!open) {
                $('#ecv-notification-tray').removeClass('ng-hide');
                $rootScope.ntClosed = false;
            } else {
                $rootScope.ntClosed = !$rootScope.ntClosed;
            }
        }

        appVm.addTeammember = () => {
            if (appVm.glblNavDisabled) {
                return false;
            }
            AppService.initTeamSelection();
            $rootScope.returnFromMenu = {stateName: $state.current.name, stateParams: $state.params};
            $state.go('parent-dashboard', { ref: 'menu' });
        }

        appVm.addDocument = () => {
            if (appVm.glblNavDisabled) {
                return false;
            }
            AppService.initTeamSelection();
            PaymentService.checkLimitAndProceed("document", () => {
                $state.go('organize', { ref: 'menu' });
            });
        }

        appVm.addDiscussion = () => {
            if (!appVm.glblNavDisabled) {
                PaymentService.checkLimitAndProceed("discussion", () => {
                    AppService.initTeamSelection();
                    $state.go('connect', { ref: 'menu' });
                });
            }

            return true;
        }

        appVm.isCurrentView = ($event, vu: string) => {

            AppService.initTeamSelection(); //if there is only one CR then select the team by default
            //This is called because when clicking Add Cr button the Cr selector is reset, then if the user clicks
            //on any navigation menu link theCR does not get set to the default team.


            if (!!$event) {
            }
            let p = $state.current.name;
            p = p.replace(/\./g, '/')
            console.log("STATENAME:", p);
            if (p[p.length - 1] == '/') {
                p = p.substring(0, p.length - 1);
            }
            if (p.indexOf('/') >= 0) {
                p = p.substring(p.lastIndexOf('/') + 1);
            }
            const samepage = p == vu;
            if (samepage && vu == 'list-document') {
                $state.go('documents-load', { action: 'list-document', stateParams: { folderId: null } }, { reload: true });
            }
            if (samepage && !!$event) {
                $event.stopPropagation()
                $event.preventDefault();
            }
            return samepage;
        }
        appVm.handleProcess = (child, noDisc, msg, changeSubject) => {
            if (!!changeSubject) {
                $rootScope.selectChild(child).then(() => {
                    if (child == -1) {
                        appVm.selectedChild = null;
                    } else {
                        appVm.selectedChild = CacheService.currentSubject || child;
                    }
                    if ($state.current.name == 'organize') {
                        BroadcastService.broadcast('cr-switched');
                    }

                    $rootScope.childChanged = true;
                    if (noDisc) {
                        PopUpService.openInformationModal(msg).then(() => {
                            let prevSub = CacheService.getPreviousSubject();
                            if (!!prevSub) {
                                if ($state.current.name == 'discussion-board-discuss' ||
                                    $state.current.name == 'discussion-board-comment' || $state.current.name == 'discussion-board-list') {
                                    $state.go("discussions-load",{action:"discussion-board-list",stateParams:{}},{reload:true});
                                }
                            }
                        });
                    } else if ($state.current.name == 'discussion-board-discuss' || $state.current.name == 'discussion-board-comment') {
                        // Prevent page reload if the user selects the subject, the disc already belongs to
                        if (!!child && child != -1 && !!$rootScope.activeResourceSubjectId && $rootScope.activeResourceSubjectId !== child.subjectId) {
                            $state.go("discussions-load",{action:"discussion-board-list",stateParams:{}},{reload:true});
                        }
                    } else if ($state.current.name == 'view-document') {
                        //Open share popup for resource folder document
                        $timeout(() => {
                            if ($rootScope.openShare) {
                                let obj = $rootScope.openShare;
                                let eligibleUsers = TeamVaultService.getUsersEligibleForShare(child.subjectId, obj.item.id, null, obj.item.postType || null);
                                PopUpService.openSharePopup(obj.item, obj.item.id, eligibleUsers, obj.item.documentUsers, obj.dispAs, false, obj.icon, obj.iconBgColor, true, obj.msgs);
                                $rootScope.openShare = null;
                            } else if (!!child && child != -1 && !!$rootScope.activeResourceSubjectId && $rootScope.activeResourceSubjectId !== child.subjectId) {
                                // Prevent page reload if the user selects the subject the document already belongs to
                                $state.go('documents-load', { action: 'list-document' }, { reload: true });
                            }
                        }, 10);
                    } else if ($state.current.name == 'list-document') {
                        //If user is inside a team folder and a different team is selected from
                        // the global selector then redirect the user to the org teams folder
                        let crntFldr = appVm.$_docFolderSvc.fetchFolderById($state.params.folderId);
                        if (child != -1 && !!crntFldr.subjectId && crntFldr.subjectId != child.subjectId) {
                            let fldr = appVm.$_docFolderSvc.fetchFolderByFolderType(FolderTypeCodes.ENTERPRISE_TEAMS);
                            $state.go('documents-load', { action: 'list-document', stateParams: { folderId: fldr.id } }, { reload: true });
                        } else {
                            $state.go('documents-load', { action: 'list-document' }, { reload: true });
                        }
                    } else if ($state.current.name == 'parent-my-folio-view-document') {
                        $state.go('parent-my-folio-list-documents', {}, { reload: true });
                    } else if ($state.current.name == 'cr-profile' && child == -1) {
                        $state.go('parent-carefeed', {}, { reload: true });
                    } else if ($state.current.name == 'parent-dashboard' && !$state.params.ref) {
                        let teamId = child == -1 ? '' : child.subjectId;
                        $state.go('parent-dashboard', { team: teamId }, { reload: true, });
                    } else if ($state.current.name == 'forms.manage') {
                        if (!!$rootScope.qckAssgnFrm) {
                            FormService.qckAssgnFrm($rootScope.qckAssgnFrm, child.subjectId, appVm.currentUserId);
                            $rootScope.qckAssgnFrm = null;
                        } else if (!!$state.params.subjectId) {
                            $state.go('parent.forms.manage-forms', { page: $state.params.page, subjectId: "" }, { reload: true, });
                        } else {
                            $state.go($state.current, {}, { reload: true, });
                        }
                    } else if ($state.current.name == 'parent.forms.fill') {
                        // Prevent page reload if the user selects the subject the form already belongs to
                        if (!!child && child != -1 && !!$rootScope.activeResourceSubjectId && $rootScope.activeResourceSubjectId !== child.subjectId) {
                            $state.go('parent.forms.manage-forms', {}, { reload: true, });
                        }
                    } else if ($state.current.name == 'view-report') {
                        try {
                            let rData = JSON.parse(atob($state.params.reportData));
                            if (!!rData.subjectId) {
                                rData = { reportId: rData.reportId, reportName: rData.reportName }; // remove extra fields
                                $state.go('view-report', { reportData: btoa(JSON.stringify(rData)) }, { reload: true, });
                            } else {
                                $state.go($state.current, {}, { reload: true, });
                            }
                        } catch (e) {
                            console.log(e);
                            $state.go($state.current, {}, { reload: true, });
                        }
                    } else if ($state.current.name == "parent.services.view") {
                        $state.go("parent.services.manage", { page: "currentServices" }, { reload: true });
                    } else if ($state.current.name == 'parent-globalDashboard') {
                        $state.go('dashboard-load',{reload:true});
                    } else {
                        $state.go($state.current, {}, { reload: true, });
                    }
                    $window.scrollTo(0, 0);
                });
            }
        }
        appVm.selectCR = (child, $event) => {
            let noDisc = false, canAssignForm = false, changeSubject = true;
            let msg = "";
            if (!!child.customChoice) {
                if (child.slug == "all-teams") {
                    child = (-1);
                }
            }
            appVm.$_searchSvc.reset();
            if (child != -1) {
                //Fetch the latest from the cache
                if (($state.current.name == 'connect' || $state.current.name == 'discussion-board-list' ||
                    $state.current.name == 'discussion-board-comment' || $state.current.name == 'discussion-board-discuss') && !$_teamPerm.isDiscussionsAllowed(child)) {
                    msg = Util.NO_MODULE_PERM.replace('$orgName', child.teamOrgName).replace('$moduleName', 'Discussions');
                    child = (-1);

                    BroadcastService.broadcast('unset-subject');
                    noDisc = true;
                }
                //For quick assign of forms,check if assignment is possible for the selected team
                // only then change the current subject.
                if ($state.current.name == 'forms.manage' && !!$rootScope.qckAssgnFrm) {
                    let form = angular.copy($rootScope.qckAssgnFrm);
                    //To allow self-assign for a particular subject only through user Experience
                    let allowFor = Util.safeAccess(CacheService.getUserExperience(), ['features', 'availableForms', 'selfAssignScope']);

                    PermissionService.isActionAllowed(child.teamPartyId, TargetEnum.FORM, PermissionsEnum.SELF_ASSIGN).then((isPermited) => {
                        if (FormService.isFormAssignable(child, form, isPermited, appVm.currentUser, allowFor)) {
                            const userTypes = eCareVault[TEAMS_FILTER];
                            let applicableSubjType = form.applicableSubjectTypeValue;
                            for (const type in userTypes) {
                                if (child.subjectTypeId == userTypes[type].filterMapValue) {
                                    let userTypeId: number = userTypes[type].typeId;
                                    if ((applicableSubjType & userTypeId) == userTypeId) {
                                        canAssignForm = true;
                                    }
                                }
                            }

                            if (!canAssignForm) {
                                changeSubject = false;
                                toastr.success(Util.FORM_NOT_AVAILABLE);
                            }
                        } else {
                            changeSubject = false;
                        }

                        if (!changeSubject) {
                            $rootScope.openCRDropDown();
                        }
                        appVm.handleProcess(child, noDisc, msg, changeSubject)
                    })
                }                    // When a user selects a new subject before saving changes in a form, a confirmation popup appears.
                // This code runs before the user responds, so we avoid changing the subject until they act.
                else if ($state.current.name === 'parent.forms.fill' && !!$rootScope.activeResourceSubjectId && child.subjectId !== $rootScope.activeResourceSubjectId && $rootScope.isFormChanged()) {
                    // If they confirm, we proceed with the new subject selection.
                    // For this purpose, We store the subject the user attempted to select earlier.
                    $rootScope.latestSelectedSubject = child;
                    $state.go($state.current, {}, { reload: true, });
                } else {
                    appVm.handleProcess(child, noDisc, msg, changeSubject)
                }
            } else {
                appVm.handleProcess(child, noDisc, msg, changeSubject)
            }
        };

        appVm.toggleSideBar = (param) => {
            if ('sidebar' === param) {
                appVm.sideBarToggle = !appVm.sideBarToggle;
            } else {
                appVm.sideBarToggle = false;
            }
        };

        appVm.toggleSlidingMenu = (event, visible) => {
            if (!!visible) {
                if (!!CacheService.getCurrentSubject()) {
                    const crntSub = CacheService.getCurrentSubject();
                    appVm.viewPrTxt = "View Care Recipient Profile";
                    if (crntSub.subjectTypeId == 'PROJECT') {
                        appVm.viewPrTxt = "View Project Profile";
                    }
                    appVm.displayCRMenu = true;
                } else {
                    appVm.displayCRMenu = false;
                }
                angular.element('.ecv-sliding-menu').addClass('ecv-menu-visible');
                angular.element('.ecv-sliding-menu-overlay').addClass('ecv-menu-overlay-visible');
            } else {
                if (!!event && (event.target.className.includes('stop-click') == true || event.target.className.includes('mugshot-initals') == true
                    || event.target.className.includes('mugshot-img') == true)) {
                } else {
                    angular.element('.ecv-sliding-menu').removeClass('ecv-menu-visible');
                    angular.element('.ecv-sliding-menu-overlay').removeClass('ecv-menu-overlay-visible');
                }
            }
        };

        const showFirefoxError = function () {
            if (window.navigator.userAgent.indexOf("Firefox") > -1) {
                let msg = `<span class="tst-info">To receive live updates while using eCare Vault, try
                    <a target="_blank" href="https://www.microsoft.com/en-us/windows/microsoft-edge">Microsoft Edge</a>,
                    <a target="_blank" href="https://www.google.com/chrome/browser/desktop/index.html">Google Chrome</a>,
                        or <a target="_blank" href="https://support.apple.com/downloads/safari">Apple Safari</a>.</span>`;
                const msgToast = toastr.success(msg, "", {
                    timeOut: 0,
                    extendedTimeOut: 0,
                    closeButton: false
                });
            }
        }
        const postLoginProcess = function () {
            if (!CacheService.getPassword()) {
                let callFn;
                if (CacheService.isVaultKeyResetRequired()) {
                    callFn = PasswordCollectorService.openExpiredPasswordModal;
                } else {
                    callFn = PasswordCollectorService.openPasswordModal;
                }
                callFn().then(() => {
                    showFirefoxError();
                    WebSocketService.createSocket();
                    BroadcastService.broadcast('update-notifications');
                    // Refresh the cf page and show the popups after the posts are loaded.
                    BroadcastService.broadcast('user-logged-in');
                }, (e) => {
                    console.log(e);
                });
            } else {
                showFirefoxError();
                WebSocketService.createSocket();
            }
        }

        //For bulk-import users, show the bottom tray informing that documents may be in processing.
        if (!!$rootScope.firstLogin) {
            $rootScope.firstLogin = false;
            if (CacheService.get('userMembership', true) > 0) {
                appVm.fetchDocs = true;
                let module = 'doc';
                let tstId = 'doc-processing-toast';
                let fn = function () {
                    $_snack.cleanup(tstId);
                }
                $_snack.addSnackbarItem(module, {
                    message: '<div id="' + tstId + '">' + Util.DOCS_PROCESSING + '</div>',
                    notificationId: tstId
                }, fn);
            }
        }

        const inviteCode = window.sessionStorage["ecvInvite"];
        const _callBack = function (s) {
            ApiAdapterService.processInvitation(inviteCode, s.value).then(
                (data) => {
                    $rootScope.mainShowLoader = false;
                    const invitedAsCoCaptain = data.coCaptain;
                    if (!!inviteCode) {
                        CacheService.setSortedSubjects([]);
                        SubjectService.getSubjectsPgWise(0).then(
                            () => {
                                SubjectService.getSubjectById(data.subjectId).then(selectedTeam => {
                                    const totalSubjs = CacheService.getTotalSubjects();
                                    const invitation = CacheService.getInviteInfo();
                                    if (invitation.subjectName) {
                                        let subjType;
                                        if (selectedTeam.subjectTypeId == "INDIVIDUAL") {
                                            subjType = Util.truncateLongText(selectedTeam.firstName, 30) + "'s";
                                        } else {
                                            subjType = "the " + Util.truncateLongText(selectedTeam.projectName, 30) + " Project";
                                        }

                                        let success_msg = Util.JOIN_TEAM_SUCCESS.replace('$subject', subjType);
                                        if (!!invitedAsCoCaptain) {
                                            success_msg = Util.COCAPTAIN_JOIN_TEAM_SUCCESS.replace('$subject', subjType);
                                        }
                                        let msg = success_msg + Util.ACCEPT_INVITATION_VIEW_POPUP;
                                        let toastId = "team-" + selectedTeam.subjectId;
                                        const onclickFunc = function () {
                                            $_snack.cleanup(toastId);
                                            $state.go('parent-dashboard', { team: selectedTeam.subjectId }, { reload: true });
                                        }
                                        $_snack.showInvitationToastr({
                                            message: msg,
                                            notificationId: toastId
                                        }, onclickFunc);
                                        appVm.fetchDocs = true;
                                        delete window.sessionStorage["ecvInvite"];
                                        CacheService.resetInviteInfo();

                                        if (!!selectedTeam) {
                                            CacheService.setCurrentSubject(selectedTeam);
                                            $scope.currentSubject = selectedTeam;
                                        }
                                    }
                                    if (!CacheService.getPassword()) {
                                        //postLoginProcess();
                                        if (totalSubjs > 0) {
                                            $state.go('parent-carefeed', {}, { reload: true, });
                                        } else if (!$rootScope.canUsrCreateTeam || (appVm.currentPlan.planType == "FREE" && !appVm.currentPlan.max)) {
                                            $state.go('parent-profile', { page: 'myProfile' });
                                        } else {
                                            $state.go('parent-addrecipient', {}, { reload: true });
                                        }
                                    } else {
                                        $rootScope.showSolidBg = false;
                                        if (totalSubjs > 0) {
                                            $state.go('parent-carefeed', {}, { reload: true, });
                                        } else if (!$rootScope.canUsrCreateTeam || (appVm.teamInvitation.length == 0 && appVm.currentPlan.planType == "FREE" && !appVm.currentPlan.maxCR)) {
                                            $state.go('parent-profile', { page: 'myProfile' });
                                        } else {
                                            $state.go('parent-addrecipient', {}, { reload: true });
                                        }
                                    }
                                });
                            }
                        );
                    } else {
                        delete window.sessionStorage["ecvInvite"];
                        CacheService.resetInviteInfo();
                        $state.go($state.current, {}, { reload: true, });
                    }
                }, () => {
                    $rootScope.mainShowLoader = false;
                    CacheService.resetInviteInfo();
                    delete window.sessionStorage["ecvInvite"];
                    PopUpService.openInformationModal('The invitation code seems to be invalid. Please try again.', null, null, null, false, 'above-password-modal').then(
                        () => {
                            $state.go($state.current, {}, { reload: true, });
                        }
                    );
                });
        };

        if (!!inviteCode) {
            ApiAdapterService.getInvitationInfo(inviteCode).then(
                (s1: InviteInfo) => {
                    $rootScope.joinedTeamId = s1.subjectId;
                    $rootScope.mainShowLoader = false;
                    if ($rootScope.inviteDeleted != true) {
                        if (s1.status == "INVITATION_INVALIDATED" || s1.status == "USED") {
                            let msg = Util.INVITATION_EXPIRED.replace('$subject', s1.subjectName);
                            if (s1.status == "USED") {
                                msg = Util.INVITATION_ALREADY_USED.replace('$subject', s1.subjectName);
                            }

                            const info_msg = null;
                            PopUpService.openInformationModal(msg, null, 'msgWithInfo', info_msg, false, 'above-password-modal').then(() => {
                                delete window.sessionStorage["ecvInvite"];
                            }, (e) => {
                                console.log(e);
                            }).finally(() => {
                                postLoginProcess();
                            });
                        } else if (!s1.adminInvite) {
                            CacheService.setAdminInvite(s1.adminInvite);
                            CacheService.setMemberName(s1.inviterName);
                            CacheService.setSubjectName(s1.subjectName);
                            CacheService.setInviteStatus(s1.status);
                            CacheService.setInvitationExpired(s1.isInvitationExpired);
                            const s2 = { 'value': '-000000' };
                            _callBack(s2);
                        } else {
                            postLoginProcess();
                        }
                    } else {
                        postLoginProcess();
                    }
                },
                () => {
                    $rootScope.mainShowLoader = false;
                    delete window.sessionStorage["ecvInvite"];
                    postLoginProcess();
                });
        } else { //self signup or login
            if (!CacheService.getPassword()) {  //login
                const passwordModal = angular.element('body').find('.password-modal');
                let promise;
                if (passwordModal.length == 0) {
                    if (CacheService.isVaultKeyResetRequired()) {
                        promise = PasswordCollectorService.openExpiredPasswordModal();
                    } else {
                        promise = PasswordCollectorService.openPasswordModal();
                    }
                } else {
                    promise = (passwordModal.scope() as any).passwordCollectorVm.$uibModalInstance.result;
                }
                promise.then(function () {
                    showFirefoxError();
                    WebSocketService.createSocket();
                    BroadcastService.broadcast('update-notifications');

                    //Show the popups only if its not redirecting to the cf page.
                    if ($state.current.name != "parent-carefeed" && $state.current.name != "manage-carefeed") {
                        AppService.showPostLoginPopups();
                    }
                    // In case of cf page, the popups will be shown after the posts are loaded.
                    BroadcastService.broadcast('user-logged-in');

                    let redirectTo = JSON.parse(localStorage.getItem("redirect_url"));
                    let redirectUrl;
                    redirectTo && (redirectUrl = redirectTo.path);
                    if (redirectUrl !== null && redirectUrl !== undefined && redirectUrl !== '') {
                        $location.path(redirectUrl);
                    }
                }, function (e) {
                    console.log(e);
                }).finally(function () {
                    localStorage.removeItem("redirect_url");
                });
            }// self-sign up or reload
            else {
                if ($rootScope.showfirefoxErr) {
                    showFirefoxError();
                    $rootScope.showfirefoxErr = false;
                }
                WebSocketService.createSocket();
                $rootScope.afterSelfSignUp = true;
            }
        }

        // Send invite from Invite Now CTA & Resend Invite
        appVm.sendInvite = (user, subject) => {
            BroadcastService.broadcast('show-loading-on-team-invitation-panel');
            if (!subject) {
                subject = appVm.subject;
            }

            $_teamService.sendInvitation(user, subject).then(() => {
                $rootScope.getTeamActions();
                appVm.canReloadState();
                BroadcastService.broadcast('update-team-invitation-panel', ['resendInvite']);
            });
        };

        // send reminder from care team action
        appVm.sendReminder = (subject, user) => {
            BroadcastService.broadcast('show-loading-on-team-invitation-panel');
            $rootScope.mainShowLoader = true;
            const selectedSubject = (subject != null ? subject : appVm.subject);
            $_teamInvitation.sendReminder(selectedSubject, user).then(
                () => {
                    $rootScope.getTeamActions();
                    appVm.canReloadState();
                    BroadcastService.broadcast('update-team-invitation-panel', ['sendReminder']);
                },
                () => {
                    $rootScope.mainShowLoader = false;
                }
            );
        }

        appVm.canReloadState = () => {
            if ($state.current.name == "parent-dashboard") {
                $state.reload();
            }
        }

        // process suggestion from care team action
        appVm.processSuggestion = (subject, user, approved) => {
            $_teamInvitation.processSuggestion(subject, user, approved).then(() => {
                $rootScope.getTeamActions();
                appVm.canReloadState();
            }, () => {
                console.log('error while processing suggestions');
            })
        }

        // request expired invitation again
        appVm.requestInvite = (subject) => {
            $rootScope.mainShowLoader = true;
            ApiAdapterService.requestAnotherInvite(subject.invitation.token).then(() => {
                $rootScope.mainShowLoader = false;
                toastr.success('The invitation request has been sent successfully.', '');
            }, (e) => {
                console.log('Error while sending invitation request' + e);
                $rootScope.mainShowLoader = false;
            });
        }

        //Accept invitation from care team action
        appVm.joinNow = (subject) => {
            if (!subject.invitation.adminInvite) {
                BroadcastService.broadcast('show-loading-on-team-invitation-panel');
                window.sessionStorage['ecvInvite'] = subject.invitation.token;
                CacheService.setAdminInvite(subject.invitation.adminInvite || false);
                CacheService.setMemberName(subject.invitation.inviterName);
                CacheService.setSubjectName(subject.firstName + ' ' + subject.lastName);
                CacheService.setInviteStatus(subject.invitation.status);
                CacheService.setInvitationExpired(subject.invitation.isInvitationExpired);


                let subOrProjName;
                if (subject.subjectTypeId == 'INDIVIDUAL') {
                    subOrProjName = subject.fullName + "'s";
                } else {
                    subOrProjName = "the " + subject.projectName + " Project";
                }

                const s2 = { 'value': '-000000' };
                $rootScope.mainShowLoader = true;

                SubjectService.getSubjectById(subject.subjectId).then(existingSub => {
                    $_teamService.joinTeam(s2).then(
                        (t) => {
                            $rootScope.getTeamActions().finally(() => {
                                $rootScope.mainShowLoader = false;
                            });
                            if (!!t) {
                                let success_msg = Util.JOIN_TEAM_SUCCESS.replace('$subject', subOrProjName);
                                if (!!t.coCaptain) {
                                    success_msg = Util.COCAPTAIN_JOIN_TEAM_SUCCESS.replace('$subject', subOrProjName);
                                }
                                CacheService.setSortedSubjects([]);
                                let subs = CacheService.getSubjects();
                                let ind = subs.findIndex(sub => sub.subjectId == subject.subjectId);
                                (ind >= 0) && (subs.splice(ind, 1));
                                CacheService.setSubjects(subs);
                                SubjectService.getSubjectsPgWise(0).then(() => {
                                    BroadcastService.broadcast('refresh-teams-drpdn');
                                    SubjectService.getSubjectById(subject.subjectId).then(selSubj => {
                                        let curSub = CacheService.getCurrentSubject();
                                        if (!!curSub && curSub.subjectId == selSubj.subjectId) {
                                            CacheService.setCurrentSubject(selSubj);
                                            $scope.currentSubject = selSubj;
                                            BroadcastService.broadcast('refresh-cr');
                                        }
                                        BroadcastService.broadcast('add-new-team', [selSubj.teamPartyParentId]);
                                        //If re-joining a former team, then update docs/disc
                                        if (!!existingSub) {
                                            BroadcastService.broadcast('team-updates', [selSubj.subjectId, 'JOINED']);
                                            let mem = {
                                                'id': appVm.currentUserId,
                                                'isFormerTeamMember': false
                                            };
                                            //Update doc users in cache
                                            $_caching.updateDocumentUserInCache(selSubj.subjectId, mem);
                                            //Update doc users on docs/disc/carefeed page
                                            BroadcastService.broadcast('doc-user-updates', [selSubj.subjectId, mem]);
                                        }
                                        if ($rootScope.glblNavDisabled) {
                                            toastr.success(success_msg, "");
                                            $state.go('parent-carefeed', {}, { reload: true, });
                                        } else {
                                            let suffix;
                                            if (subject.subjectTypeId == 'INDIVIDUAL') {
                                                suffix = Util.truncateLongText(subject.firstName, 30) + "'s team";
                                            } else {
                                                suffix = "the " + Util.truncateLongText(subject.projectName, 30);
                                            }
                                            // Update the team invitation panel if user accepts individual team invitation
                                            BroadcastService.broadcast('update-team-invitation-panel', ['accept']);
                                            let msg = "You have joined " + suffix + "." + Util.ACCEPT_INVITATION_POPUP;
                                            let toastId = "team-" + selSubj.subjectId;
                                            const onclickFunc = function () {
                                                $_snack.cleanup(toastId);
                                                $rootScope.selectChild(selSubj).then(() => {
                                                    $state.go('parent-dashboard', { team: selSubj.subjectId }, { reload: true });
                                                });
                                            }
                                            $_snack.showInvitationToastr({
                                                message: msg,
                                                notificationId: toastId
                                            }, onclickFunc);
                                        }
                                    });
                                });
                            }
                            delete window.sessionStorage["ecvInvite"];
                            CacheService.resetInviteInfo();
                        },
                        () => {
                            $rootScope.mainShowLoader = false;
                            console.log('error while processing invitation');
                        });
                });
            }
        }

        appVm.scrollNav = (top) => {
            const sideNav = $('#side-nav');
            if (top) {
                sideNav.animate({
                    scrollTop: 0
                }, 1000);
            } else {
                sideNav.animate({
                    scrollTop: ((sideNav[0] as HTMLElement).scrollHeight - (sideNav[0] as HTMLElement).offsetHeight)
                }, 1000);
            }
        }


        appVm.updateSelectedCR = () => {
            if (!!CacheService.getCurrentSubject()) {
                $scope.currentSubject = CacheService.getCurrentSubject();

                // Refresh the discussion allowed flag for the selected CR
                appVm.isDiscAllowed = $_teamPerm.isDiscussionsAllowed();
                UserService.isUserTeammember($scope.currentSubject).then((s) => {
                    appVm.isTeammember = s
                });
            } else {
                $scope.currentSubject = null;
            }
        };
        appVm.updateSelectedCR();
        appVm.stopDropDown = (e) => {
            appVm.isAdminFeatureOpen = !appVm.isAdminFeatureOpen
            e.preventDefault();
            e.stopPropagation();
        }
        appVm.assignForm = () => {
            const body = {
                orgId: appVm.currentUser.organizationId,
                formUsers: [
                    {
                        userId: appVm.currentUserId,
                        role: "ACCESS"
                    }
                ]
            }
            $rootScope.mainShowLoader = "Loading...";
            ApiAdapterService.assignCreateProjectTeamForm(body).then((response) => {
                $rootScope.mainShowLoader = false;
                SubjectService.getSubjectById(response.subjectId).then(subject => {
                    $rootScope.selectChild(subject);
                });
                FormService.fillForm(response.assignmentId,'asf', null, true);
            }).catch((e) => {
                $rootScope.mainShowLoader = false;
                console.log('Error while assigning form:', e);
                toastr.error('Unable to assign form. Please try again.');
            });
        }
        PermissionService.isActionAllowed(appVm.currentUser.partyId, TargetEnum.ADMIN_FEATURES, PermissionsEnum.LIST).then((isPermited) => {
            appVm.isAdminFeaturePerm = isPermited
        })
        PermissionService.isActionAllowed(appVm.currentUser.partyId, TargetEnum.USER, PermissionsEnum.LIST).then((isPermited) => {
            appVm.isUserManagePerm = isPermited
        })
        PermissionService.isActionAllowed(appVm.currentUser.partyId, TargetEnum.ADMIN_FEATURES, PermissionsEnum.CREATE_TEAM).then((isPermited) => {
            appVm.isAdminFeatureCreateTeamPerm = isPermited
        })
        PermissionService.isActionAllowed(appVm.currentUser.partyId, TargetEnum.ADMIN_FEATURES, PermissionsEnum.MANAGE_SYSTEM_MESSAGE).then((isPermited) => {
            appVm.isManageSystemMessagePerm = isPermited
        })

        setTimeout(function () {
            $('.ecv-side-nav').ready(function () {
                const sideNav = document.getElementById("side-nav");
                const upChev = angular.element('.chev-up-div');
                const dwnChev = angular.element('.chev-down-div');
                if (sideNav.scrollHeight > sideNav.clientHeight) {
                    dwnChev.css('visibility', 'visible');
                } else {
                    dwnChev.css('visibility', 'hidden');
                }
                $('#side-nav').scroll(function () {
                    if (this.scrollTop == 0) {
                        upChev.css('visibility', 'hidden');
                    } else {
                        upChev.css('visibility', 'visible');
                    }
                    if (Math.round(this.scrollTop) == (this.scrollHeight - this.offsetHeight)) {
                        dwnChev.css('visibility', 'hidden');
                    } else {
                        dwnChev.css('visibility', 'visible');
                    }
                });
            });
        }, 200);
    }
}

angular.module('eCareVault')
    .controller('AppController', AppController);
